import { Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  DrawerAccordion,
  DrawerAccordionDetails,
  DrawerAccordionSummary,
  LayoutComponentNames,
  LEFT_DRAWER_MOBILE_BREAKPOINT,
  scrollToElement,
  usePageLayoutStore,
  useLayoutWithAppliedRepeaters,
} from '@diana/core';
import { IEntitySectionGroupProps } from './EntitySection.types';
import { EntitySection } from './EntitySection';

export function EntitySectionGroup({ step, work, closeDrawer }: IEntitySectionGroupProps) {
  const { breakpoints, palette } = useTheme();
  const isMobileDrawer = useMediaQuery(breakpoints.down(LEFT_DRAWER_MOBILE_BREAKPOINT));
  const setIsLeftDrawerOpen = usePageLayoutStore((store) => store.setIsLeftDrawerOpen);
  const [expanded, setExpanded] = useState<boolean>(step.isActive);

  const layout = useLayoutWithAppliedRepeaters({
    layout: step.layout,
    data: work.data,
    flowId: work.flowId,
  });

  const isEmpty = (layout?.components?.length ?? 0) <= 1;

  return (
    <DrawerAccordion
      sx={{
        px: 2,
        py: 1,
        '& .MuiButtonBase-root': {
          minHeight: '36px !important',
        },
      }}
      expanded={isEmpty ? false : expanded}
      TransitionProps={{ unmountOnExit: true }}
    >
      <DrawerAccordionSummary
        expandIcon={!isEmpty ? <ExpandMoreRoundedIcon style={{ fontSize: '24px' }} /> : null}
        onClick={() => {
          if (!isEmpty) setExpanded(!expanded);
        }}
      >
        <Typography
          variant="body1"
          sx={{
            ml: 1.4,
            cursor: 'pointer',
            lineHeight: `${24 / 14}rem`,
            color: palette.text.primary,
          }}
          onClick={(e) => {
            scrollToElement({ e, id: step.id });
            isMobileDrawer && setIsLeftDrawerOpen(false);
          }}
        >
          {step.displayName}
        </Typography>
      </DrawerAccordionSummary>
      <DrawerAccordionDetails key={layout?.components.length}>
        <>
          {layout?.components.map((component, i) => {
            if (i === 0 || component.component !== LayoutComponentNames.SECTION) return null;
            return (
              <EntitySection
                key={component.id + layout.components.length}
                color={palette.text.primary}
                workId={work.id}
                work={work}
                step={step}
                closeDrawer={closeDrawer}
                component={component}
                index={i - 1}
              />
            );
          })}
        </>
      </DrawerAccordionDetails>
    </DrawerAccordion>
  );
}
